export const BANK_STATUS_VARIANTS = {
  BANK_ASSOCIATION: "BANK_ASSOCIATION",
  BANK_INACTIVE: "BANK_INACTIVE",
  BANK_VERIFIED: "BANK_VERIFIED",
  PENDING: "PENDING",
};
